module.exports = __webpack_public_path__ + "assets/modal-topbg-b47564ed.png";